module.exports = __webpack_public_path__ + "img/wuxing.29ffcbbc.png";